/**
 * Monetary rounding — matches existing FM strategy (2 decimal pesos via Math.round).
 * Catalog/orders use NUMERIC(10,2); do not introduce a second money library here.
 */

export function roundMoney(n: number): number {
  if (!Number.isFinite(n)) return 0;
  return Math.round(n * 100) / 100;
}

export function sumMoney(values: number[]): number {
  return roundMoney(values.reduce((a, b) => a + (Number.isFinite(b) ? b : 0), 0));
}
